var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCarRed = function SvgCarRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    d: "M16.25 5.143V3.857C16.25 1.727 14.571 0 12.5 0h-5C5.429 0 3.75 1.727 3.75 3.857v1.286C1.679 5.143 0 6.87 0 9v5.143c0 .71.559 1.286 1.25 1.286H2.5v1.285c0 .711.559 1.286 1.25 1.286S5 17.425 5 16.714V15.43h10v1.285c0 .711.559 1.286 1.25 1.286s1.25-.575 1.25-1.286V15.43h1.25c.691 0 1.25-.575 1.25-1.286V9c0-2.13-1.679-3.857-3.75-3.857zM6 3.5C6 2.67 6.596 2 7.333 2h5.334C13.404 2 14 2.67 14 3.5V5H6V3.5zM18 13H3V9.25C3 8.559 3.559 8 4.25 8h12.5c.691 0 1.25.559 1.25 1.25V13zM5.5 9C4.67 9 4 9.67 4 10.5S4.67 12 5.5 12 7 11.33 7 10.5 6.33 9 5.5 9zm10 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 9 15.5 9z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car-red.064c49ad.svg";
export { ForwardRef as ReactComponent };